export function connectedGraph(data, selectedId) {
  const id = value => typeof value === 'object' ? value.id : value;
  const nodesById = new Map(data.nodes.map(node => [node.id, node]));
  if (!nodesById.has(selectedId)) return { nodes: [], links: [] };
  const neighbors = new Map(data.nodes.map(node => [node.id, []]));
  for (const link of data.links) {
    const source = id(link.source), target = id(link.target);
    if (!nodesById.has(source) || !nodesById.has(target)) continue;
    neighbors.get(source).push(target); neighbors.get(target).push(source);
  }
  const seen = new Set([selectedId]);
  const queue = [selectedId];
  for (let i = 0; i < queue.length; i++) {
    for (const next of neighbors.get(queue[i])) if (!seen.has(next)) { seen.add(next); queue.push(next); }
  }
  return { nodes: data.nodes.filter(node => seen.has(node.id)), links: data.links.filter(link => seen.has(id(link.source)) && seen.has(id(link.target))) };
}
export function touchesNode(link, nodeId) {
  const id = value => typeof value === 'object' ? value.id : value;
  return id(link.source) === nodeId || id(link.target) === nodeId;
}
